import React from "react";
import { Container, Row, Col } from "react-bootstrap";

function Banner(props) {
  return (
    <div className="services_banner">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <div className="banenr_content">
              <div className="example" data-text="Managed">
                <h1>Managed Mobility Services</h1>
              </div>
              <p className="main_para">
                Enhancing mobility experiences for your business
              </p>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <div className="banner_content_txt">
              <p>
                Tekrevol helps you set up the architecture, build mobility
                systems and assist you in performing beyond your capacity
                through effective management. We take care of everything for
                you.
              </p>
              <ul>
                <li>Efficient Planning &amp; Execution</li>
                <li>Consultation and Strategies</li>
                <li>Device Lifecycle Management</li>
                <li>Support &amp; Other Management Solutions</li>
              </ul>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Banner;
